import { ChangeDetectionStrategy, Component, inject, NgZone, signal } from '@angular/core';
import gsap from "gsap";

@Component({
  selector: 'skyscraper4',
  standalone: false,
  templateUrl: './skyscraper4.component.html',
  styleUrl: './skyscraper4.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Skyscraper4Component {
  private zone = inject(NgZone);
  public finalHeight = signal<number>(300); 
  public height = signal<number>(200);
  public width = signal<number>(400);


  ngAfterViewInit(): void {
    this.animate();
  }

  animate() {
    const obj = { x: this.height() };
    gsap.to(obj, {
      x: this.finalHeight(),
      duration: 1,
      delay: 0,
      ease: "power2.inOut",
      onUpdate: () => {
        this.zone.run(() => {
          this.height.set(obj.x);
        });
      },
    });
  }
}
